import i18n from 'i18next';
import { initReactI18next } from 'react-i18next';
import type { Locale } from '../types';
import en from './locales/en/ui.json';
import fr from './locales/fr/ui.json';

// English + French. Every UI string lives in BOTH files; English is the default and is not
// auto-selected from the browser (the toggle, and the account's `locale` once signed in, decide).
// A link can choose too, with ?lang=en|fr (the website's French pages link to /login?lang=fr): the choice is kept for
// the tab's session, so that /login → /signup and the Microsoft round trip stay in that language.
const LANG_KEY = 'sculpt.account.lang';
const isLocale = (v: string | null): v is Locale => v === 'en' || v === 'fr';

/** The language to open in: the link's ?lang, else the one kept for this tab, else English. */
export function pickLanguage(search: string, kept: string | null): Locale {
  const asked = new URLSearchParams(search).get('lang');
  if (isLocale(asked)) return asked;
  return isLocale(kept) ? kept : 'en';
}

/** Keeps a language chosen by a link or the toggle for the rest of the tab's session. */
export function rememberLanguage(locale: Locale): void {
  try {
    sessionStorage.setItem(LANG_KEY, locale);
  } catch {}
}

function keptLanguage(): string | null {
  try {
    return sessionStorage.getItem(LANG_KEY);
  } catch {
    return null;
  }
}

const lng = pickLanguage(window.location.search, keptLanguage());
if (new URLSearchParams(window.location.search).has('lang')) rememberLanguage(lng);

void i18n.use(initReactI18next).init({
  resources: { en: { translation: en }, fr: { translation: fr } },
  lng,
  fallbackLng: 'en',
  interpolation: { escapeValue: false },
});

export default i18n;
